/**
 * Client-side helpers mirroring serverless/common/office/officeRewriteDefaults.
 * Used when building office create/update payloads from Manage Firm / Catalogs.
 */

export function resolveRewriteOfficeMembershipType(
  officeType?: string | null,
  membershipType?: string | null,
): string {
  const existing = String(membershipType ?? "").trim().toLowerCase();
  if (existing === "primary") {
    return "primary";
  }
  if (existing === "multiple" || existing === "multiple primary") {
    return "multiple";
  }
  if (existing === "secondary") {
    return "secondary";
  }
  if (existing === "regional") {
    return "regional";
  }
  if (existing === "other") {
    return "other";
  }
  if (existing) {
    return existing;
  }

  const type = String(officeType ?? "").trim().toLowerCase();
  if (type === "main") {
    return "primary";
  }
  if (type === "additional" || type === "branch") {
    return "multiple";
  }
  return "other";
}

export function defaultShowInDirectory(
  current?: boolean | null,
): boolean {
  return current == null ? true : current;
}
